import { Component } from "@angular/core";
import {
  PresetNote,
  PresetNoteSearchParams,
} from "../shared/models/order.model";
import { ServiceMetaData } from "../shared/models/service-meta.model";
import { PaginationParams } from "../shared/models/common";
import { AppState } from "../shared/redux/store";
import { AuthService } from "../shared/services/auth.service";
import { BroshService } from "../shared/services/brosh.service";
import { DataService } from "../shared/services/data.service";
import { keyCodes } from "../shared/models/key-codes.model";
import { Store } from "@ngrx/store";
import {
  presetNotes,
  presetNotesSearchMetadata,
} from "../shared/ngrx/ngrx-selectors";
import { FormEnhanceDirective } from "../shared/components/ui/form-enhance.directive";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { InputWrapComponent } from "../shared/components/ui/input-wrap.component";
import { ModalPopupComponent } from "../shared/components/ui/modal-popup.component";
import { LoaderComponent } from "../shared/components/ui/loader/loader.component";
import { TableComponent } from "../shared/components/ui/table/table.component";
import { EditPresetNoteComponent } from "./edit-preset-note/edit-preset-note.component";

@Component({
  selector: "app-note-catalog",
  templateUrl: "./note-catalog.component.html",
  styleUrls: ["./note-catalog.component.scss"],
  imports: [
    CommonModule,
    FormsModule,
    InputWrapComponent,
    TranslateModule,
    FormEnhanceDirective,
    ModalPopupComponent,
    LoaderComponent,
    TableComponent,
    EditPresetNoteComponent,
  ],
  standalone: true,
})
export class NoteCatalogComponent {
  loading: boolean;
  numberOfRows: number = 15;
  rangeFrom: number = 1;
  rangeTo: number = this.numberOfRows;
  searchParams: PresetNoteSearchParams = new PresetNoteSearchParams();
  filterNoteText?: string;
  curNote: PresetNote;
  displayEditNote: boolean;
  runningNew: boolean = true;

  get searchMetaData(): ServiceMetaData {
    return this.store.selectSignal(presetNotesSearchMetadata)() || {};
  }

  get data(): PresetNote[] {
    return this.store.selectSignal(presetNotes)();
  }

  get allowCreate(): boolean {
    return this.authService.currentUser.roleCode == "ADMIN";
  }

  constructor(
    private readonly store: Store,
    private broshService: BroshService,
    private authService: AuthService,
    private dataService: DataService
  ) {}

  ngOnInit(): void {
    this.getData(true);
  }

  resetSearchParams() {
    this.searchParams = new PresetNoteSearchParams();
  }

  clearSearch() {
    this.filterNoteText = null;
    this.search();
  }

  search() {
    this.searchParams.noteText = this.filterNoteText;
    this.getData(true);
  }

  getData(newSearch: boolean) {
    if (newSearch) {
      this.runningNew = true;
      this.searchParams.searchId = null;
      this.searchParams.rangeFrom = 1;
      this.searchParams.rangeTo = this.numberOfRows;
    }

    this.loading = true;
    this.broshService.getPresetNotes(this.searchParams).subscribe(
      () => {
        this.runningNew = false;
        this.loading = false;
      },
      () => (this.loading = false)
    );
  }

  loadDataOnPagination(event: PaginationParams) {
    if (
      !this.data ||
      (event.rangeFrom == this.searchParams.rangeFrom &&
        event.rangeTo == this.searchParams.rangeTo)
    )
      return;

    this.searchParams.rangeFrom = event.rangeFrom;
    this.searchParams.rangeTo = event.rangeTo;
    this.searchParams.searchId = this.searchMetaData.searchId;

    this.getData(false);
  }

  createNote() {
    this.curNote = new PresetNote();
    this.curNote.displayLabSw = true;
    this.displayEditNote = true;
  }

  onRowSelect(row: PresetNote) {
    this.curNote = row;
    this.displayEditNote = true;
  }

  onSave() {
    this.displayEditNote = false;
    this.getData(true);
  }

  onKeyPress(e: any) {
    if (e.keyCode == keyCodes.enter) {
      this.search();
    }
  }

  getStatusColor(row: PresetNote): string {
    if (row.status == "PENDING") {
      return "rgb(250, 179, 63)";
    } else if (row.status == "ACTIVE") {
      return "rgb(28, 201, 122)";
    } else {
      return "rgb(218, 119, 242)";
    }
  }
}
